import React from 'react'

const GlossaryPage = () => {
  return (
    <section>
      <p>
        USCY Glossary (Canonical Definitions) USCY A GENIUS-aligned USD
        stablecoin backed 1:1 by cash reserves held in a Delaware statutory
        trust and custodied at Northern Trust. USCY is always redeemable at par
        and uses a vault-based model to preserve yield continuity for the
        institution that supplied the collateral. Vault A dedicated, immutable
        collateral unit created each time an eligible customer mints USCY. The
        vault stores the principal amount, accrues that institution&apos;s share
        of underlying yield until redemption, and participates in the global
        vault redemption queue. Vault Queue A deterministic, chronological
        sequence that governs redemption order for all open vaults. New vaults
        enter at the front. Front = next to be redeemed (shortest remaining
        reward duration). Rear = longest time until redemption (longest reward
        duration). Queue Position A vault&apos;s location within the redemption
        queue. Determines how long a vault continues to accrue rewards before
        closure. Queue Drift The natural movement of vaults through the queue
        driven by changes in total USCY supply. Supply expansion: older vaults
        tend to drift backward (longer reward duration). Supply contraction:
        vaults move forward (shorter reward duration). YPPs allow institutions
        to override natural drift. Temporary Vault Protection A short, automatic
        protection period granted to every new vault until the next reward
        cycle. Prevents immediate redemption and allows time for optional YPP
        allocation. Redemption The process where an eligible customer returns
        USCY and receives USD at par. Redemptions always close the vault at the
        front of the queue. Closed Vault A vault that has been redeemed against.
        It stops accruing rewards permanently but retains its historical yield
        record. Accrued Rewards The cumulative yield allocated to a vault from
        the underlying trust assets. Calculated net of platform fees and visible
        to the vault owner until the vault closes. USCY Digital Asset LLC The
        platform operator responsible for onboarding, compliance, vault
        creation, queue management, reward allocation logic, and system
        integrity. Does not issue tokens or custody client funds. USCY Reserves
        Trust A Delaware statutory trust that holds beneficial ownership of the
        USD reserves backing USCY. Ensures bankruptcy-remote treatment and
        segregated client-asset status. FBO Account (“For Benefit Of”) A
        custodian account structure used at Northern Trust: “Brale FBO USCY
        Reserves Trust.” Brale is the account administrator, not the owner.
        Funds are legally owned by the Trust and treated as client monies.
        Issuer (Brale) A regulated U.S. Money Services Business (MSB)
        responsible for minting and burning USCY tokens. Brale maintains the FBO
        account solely as an administrative agent for the Trust. Custodian
        (Northern Trust) Holds the cash reserves backing USCY in segregated
        client-money accounts. Provides auditability, regulatory oversight, and
        institutional-grade safekeeping. Yield Protection Points (YPPs) A
        non-yield-bearing utility token issued by an independent Cayman
        foundation. YPPs enable institutions to shift vaults down the queue,
        extending reward duration. They do not represent ownership, revenue
        share, governance rights, or claims on USCY reserves. YPP Foundation A
        Cayman-based independent foundation responsible for issuing YPPs,
        managing incentives, and administering reward programmes aligned with
        USCY ecosystem growth. Incentive Programmes Structured frameworks
        defined by the YPP Foundation that allow institutions to earn YPPs
        through platform participation, liquidity provision, early adoption, or
        other approved engagement. Yield Separation A design principle where
        yield attaches to vaults, not token balances. Institutions maintain
        economic continuity even as their USCY tokens move through trading,
        settlement, or treasury workflows. GENIUS Alignment Compliance with
        principles that require: The stablecoin to remain a digital
        representation of USD No yield transfer to tokens Yield accruing only at
        the account/vault level 1:1 par redemption Transparent segregation of
        issuer, trust, and custodian Operational Velocity The level of real-time
        usage of USCY in trading, settlement, or treasury flows. In contrast to
        other stablecoins, operational velocity does not affect reward
        continuity. Redemption Event The moment a vault at the front of the
        queue is closed to satisfy a user&apos;s redemption request. Ends yield
        accrual for that vault. Collateral Lifecycle The full lifecycle of a
        vault: mint → accrual → queue movement → closure. Par Redemption A
        guaranteed mechanism delivering exactly 1 USD per 1 USCY to eligible
        customers without slippage or discount.
      </p>
    </section>
  )
}

export default GlossaryPage